var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueEditor',{attrs:{"use-custom-image-handler":"","editor-toolbar":_vm.customToolbar},on:{"image-added":_vm.handleImageAdded},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }